import React from 'react';
import { m } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
export function AboutAuthor() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-22" data-mp="2hf4lkrab19s1">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-23" data-mp="2m9h6z6vccv6f">
        <div className="mb-6 text-center" data-id="element-24" data-mp="2q9j6b9dltcij">
          <SectionTag icon="🏀" data-id="element-25" data-mp="2q99fxkond3cb">Acerca de Manuales Listos</SectionTag>
        </div>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center gap-8 rounded-3xl border border-white/10 bg-bg-primary p-6 sm:p-10 lg:flex-row lg:items-start" data-id="element-26" data-mp="1tkjwvr1aa4or">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/7a637f51-6620-455d-8b7f-a74767f74ce7.jpg" alt="Javier Solana, entrenador formativo certificado, en el pabellón" width={320} height={400} loading="lazy" decoding="async" className="h-64 w-52 flex-shrink-0 rounded-2xl object-cover sm:h-80 sm:w-64" data-id="element-27" data-mp="27kkvt0xzn21l" />
          <div data-id="element-28" data-mp="25qdxfhjvg12r">
            <QuoteIcon size={28} className="text-orange" data-id="element-29" data-mp="20svpnuhlbrwc" />
            <p className="mt-4 text-lg italic leading-relaxed text-white sm:text-xl" data-id="element-30" data-mp="20rawa870if02">
              "He volcado en este sistema los esquemas reales que utilizamos para transformar entrenamientos
              improvisados en sesiones con criterio profesional. Menos búsqueda en YouTube y más práctica
              efectiva en el pabellón."
            </p>
            <div className="mt-6 border-t border-white/10 pt-4" data-id="element-31" data-mp="1i1uttfbroch0">
              <p className="font-heading text-base font-semibold text-white" data-id="element-32" data-mp="1d3kwoz6hf1sr">Javier Solana</p>
              <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-33" data-mp="1d1qalhjh53n3">
                Entrenador formativo certificado. 14 años de experiencia en cantera. +600 jugadores formados
                en clubes federados de Madrid y Castilla-La Mancha.
              </p>
            </div>
          </div>
        </m.div>
      </div>
    </section>;
}